// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__LNpFc","divider-custom":"Contact_divider-custom__cgzxD","container-surat":"Contact_container-surat__1pUoZ","btn-more":"Contact_btn-more__ei5tz"};